import React from 'react';

const About = () => {
  return (
    <div>
      <h2>About Us</h2>
      <p>We are a real estate company dedicated to helping you find your dream property.</p>
    </div>
  );
};

export default About;
